import categories from './categories';
import certificates from './certificates';
import connectionTree from './connectionTree';
import documents from './documents';
import recipients from './recipients';
import users from './users';
import utility from './utility';

const API = {
  certificates,
  documents,
  connectionTree,
  utility,
  users,
  recipients,
  categories,
};

export default API;
